import React from "react";
import { FcCloseUpMode } from "react-icons/fc";

const NonWorkingTable = ({ data }) => {
  return (
    <div className="papaDiv" style={{ zIndex: 1 }}>
      {(data && data.length > 0) || <div>No Data Found</div>}
      {data && data.length > 0 && (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="1sticky-top" style={{ zIndex: 1 }}>
              <tr className="table-dark">
                <th>SNo</th>
                <th>MACHINE DATE</th>
                <th>MACHINE NAME</th>
                <th>SECTION NAME</th>
                <th>CAUSE</th>
              </tr>
            </thead>

            <tbody>
              {data.map((obj, ind) => {
                return (
                  <tr key={ind}>
                    <td>{ind + 1}</td>
                    <td>{obj.MACHINE_DATE.slice(0, 10)}</td>
                    <td>{obj.MACHINE_NAME}</td>
                    <td>{obj.SECTION_NAME}</td>
                    <td>{obj.CAUSE}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default NonWorkingTable;
